import userService from "../userService";

export async function getUserQuery(id){
    return userService.getByKey(`query/${id}`).then((r)=>r.data);
}

export async function getUserAll(){
    return userService.getAll().then((r)=>r.data);
}